import { Button, SxProps, Theme } from '@mui/material';

interface IProps {
  children?: React.ReactNode;
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  startIcon?: React.ReactNode;
  disabled?: boolean;
  color?:
    | 'inherit'
    | 'primary'
    | 'secondary'
    | 'info'
    | 'success'
    | 'warning'
    | 'error';
  sx?: SxProps<Theme>;
}

export function FSSecondaryButton({
  children,
  onClick,
  startIcon,
  disabled = false,
  color = 'primary',
  sx,
}: IProps) {
  return (
    <Button
      onClick={onClick}
      variant="text"
      color={color}
      disabled={disabled}
      sx={{
        borderRadius: '100px',
        textTransform: 'none',
        paddingRight: '20px',
        paddingLeft: '20px',
        fontSize: '14px',
        height: '40px',
        fontWeight: 'bold',
        ...sx,
      }}
      startIcon={startIcon}
    >
      {children}
    </Button>
  );
}
